import React from "react";
import { useTranslation } from "react-i18next";

import ContractsList from "features/accounting/contracts/ContractsList";
import ReceiptsList from "features/accounting/receipts/ReceiptsList";
import WithdrawsList from "features/accounting/withdraws/WithdrawsList";
import ExpensesList from "features/accounting/expenses/ExpensesList";
import VehiclePaymentsList from "features/accounting/vehicle-payments/VehiclePaymentsList";

import ServiceTemplateList from "features/accounting/service-templates/ServiceTemplateList";
import DiscountsList from "features/accounting/discounts/DiscountsList";
import EducationYearList from "features/accounting/education-years/EducationYearsList";

import Report from "features/accounting/managed-reports/ManagedReports";

import Tabs from "components/ui/tabs/Tabs";

const Accounting = () => {
  const { t } = useTranslation();

  let accountingTabs = [];

  accountingTabs.push({
    label: t("contracts"),
    content: <ContractsList />,
  });

  accountingTabs.push({
    label: t("receipts"),
    content: <ReceiptsList />,
  });

  accountingTabs.push({
    label: t("expenses"),
    content: <ExpensesList />,
  });

  accountingTabs.push({
    label: t("refunds"),
    content: <WithdrawsList />,
  });

  accountingTabs.push({
    label: t("vehicleCompensations"),
    content: <VehiclePaymentsList />,
  });

  accountingTabs.push({
    label: t("reports"),
    content: <Report />,
  });

  accountingTabs.push({
    label: t("contractTemplates"),
    content: <ServiceTemplateList />,
  });

  accountingTabs.push({
    label: t("discounts"),
    content: <DiscountsList />,
  });

  accountingTabs.push({
    label: t("servicePeriods"),
    content: <EducationYearList />,
  });

  return (
    <React.Fragment>
      <Tabs tabs={accountingTabs} isVertical={true} />
    </React.Fragment>
  );
};

export default Accounting;
